// extracted by mini-css-extract-plugin
module.exports = {"title":"style-module__title___Ro9PS","message":"style-module__message___TTedT"};